export default "__VITE_ASSET__cea0a28e__"